import { Brand } from '../types/Brand';
import { GetBrandListingSchema } from '../schemas/BrandZodSchema';

/**
 * Transforms and validates the response from the getBrandListing GraphQL query
 * to a simplified Brand type.
 *
 * @param data The response data from the getBrandListing query
 * @returns An array of valid Brand objects
 */
export function transformBrandResponse(
    data?: unknown // GetBrandListingQuery - use unknown for jest tests be able to pass invalid data
): Brand[] {
    // Parse and validate the data using the Zod schema
    const parsedResult = GetBrandListingSchema.safeParse(data);

    if (!parsedResult.success) {
        console.error('Validation failed for getBrandListing:', parsedResult.error.errors);
        return [];
    }

    const brands = parsedResult.data.getObjectFolder.children;

    // Transform brands to simplified Brand type
    return brands.map((brand) => ({
        id: brand.id,
        key: brand.key,
        name: brand.name,
        logo: brand.logo ? { fullpath: brand.logo.fullpath } : null,
    }));
}
